import { useLocation } from 'react-router-dom';

import { LocactionStateFrom, LocationState } from '../../types/location-state';

const useFromLocationState = (): LocactionStateFrom => {
    const location = useLocation<LocationState>();

    return location.state?.from || { pathname: '/' };
};

export default useFromLocationState;
